export default {
  CREATING_REGIONAL_OVERRIDE_IN_PROGRESS: "Creating Regional Override. . .",

  CREATE_REGIONAL_OVERRIDE_SUCCESS: "Regional Override was Created Successfully",

  UPDATING_REGIONAL_OVERRIDE_IN_PROGRESS: "Updating Regional Override. . .",

  UPDATE_REGIONAL_OVERRIDE_SUCCESS: "Regional Override was Updated Successfully",

  DELETING_REGIONAL_OVERRIDE_IN_PROGRESS: "Removing Regional Override. . .",

  DELETE_REGIONAL_OVERRIDE_SUCCESS: "Regional Override was Removed Successfully",

  ERROR_GETTING_REGIONAL_OVERRIDES: "There was an error getting Regional Overrides",

  ERROR_CREATING_REGIONAL_OVERRIDE: "There was an error creating Regional Override",

  ERROR_UPDATING_REGIONAL_OVERRIDE: "There was an error updating Regional Override",

  ERROR_DELETING_REGIONAL_OVERRIDE: "There was an error removing Regional Override",
};
